import React from 'react';
import {
  Modal,
  StackLayout,
  ParagraphText,
  Button,
  Image,
} from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { sendAccountSetupErrorButtonClickedEvent } from 'utils/analytics-events';
import errorIcon from 'assets/error.svg';
import { BaseModalContainer } from '../common/base-modal.component';

interface Props {
  open: boolean;
  onSkip: () => void;
  onRetry: () => void;
  onClose: () => void;
  isSkipping?: boolean;
}

export const AccountSetupSubmitErrorModal: React.FC<Props> = ({
  open,
  onSkip,
  onRetry,
  onClose,
  isSkipping = false,
}) => {
  const { formatMessage } = useIntl();
  const buttonCss = {
    minWidth: '240px',
    height: '48px',
    justifyContent: 'center',
  } as const;

  // Handle button click analytics
  const handleSkipClick = () => {
    sendAccountSetupErrorButtonClickedEvent('skip account setup');
    onSkip();
  };

  const handleRetryClick = () => {
    sendAccountSetupErrorButtonClickedEvent('try again');
    onRetry();
  };

  return (
    <Modal.Root open={open} onOpenChange={onClose}>
      <BaseModalContainer
        title={formatMessage({ id: 'STR_PROFILE_COULD_NOT_BE_UPDATED_TITLE' })}
        onClose={onClose}
      >
        <StackLayout spacing="$oneAndHalf" horizontalAlignment="center">
          <Image src={errorIcon} alt="error" width="120px" height="auto" />
          <ParagraphText css={{ textAlign: 'center' }}>
            {formatMessage({
              id: 'STR_PROFILE_COULD_NOT_BE_UPDATED_DESCRIPTION',
            })}
          </ParagraphText>

          <StackLayout spacing="$one" css={{ marginTop: '$one' }}>
            <Button
              priority="secondary"
              onClick={handleSkipClick}
              css={buttonCss}
              loading={isSkipping}
              disabled={isSkipping}
            >
              {formatMessage({ id: 'STR_SKIP_ACCOUNT_SETUP' })}
            </Button>
            <Button
              onClick={handleRetryClick}
              css={buttonCss}
              disabled={isSkipping}
            >
              {formatMessage({ id: 'STR_TRY_AGAIN' })}
            </Button>
          </StackLayout>
        </StackLayout>
      </BaseModalContainer>
    </Modal.Root>
  );
};
